
        <div class="card-head">
            <button class="btn btn-info btn-sm pull-right" (click)="openModal(actionAnomaly)">
                <i class="fa fa-plus" aria-hidden="true"></i> Nouveau
            </button>
        </div>

        <div class="card-body">
            <div class="row">
                <!-- <table class="table"> -->
                    <table datatable class="row-border hover" [dtOptions]="dtOptions" [dtTrigger]="dtTigger">
                    <thead>
                        <tr>
                            <th *ngIf="entrepriseType == '1'">Entreprise</th>
                            <th>Description</th>
                            <th>Commentaire</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of listAnomalies" class="pointer-cl">
                            <td (click)="emitDataAnomalies(item)" *ngIf="entrepriseType == '1'">{{item.entrepriseId != null ? item.entreprise.name:''}}</td> 
                            <td (click)="emitDataAnomalies(item)">{{item.description}}</td>
                            <td (click)="emitDataAnomalies(item)">{{item.comment}}</td>
                            <td>
                                <button class="btn btn-sm btn-danger" (click)="beforeDelete(item.id)">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

<ng-template #actionAnomaly>
    <div class="modal-header">

        <h4 class="modal-title" *ngIf="checkAction === 'add'">Nouveau Anomalie</h4>
        <h4 class="modal-title" *ngIf="checkAction === 'update'">Modifier Anomalie</h4>

        <button type="button" class="close" aria-label="Close" (click)="resetField()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label>Déscription</label>
            <input type="text" class="form-control" name="anomalyDescription" [(ngModel)]="anomalyDescription">
        </div>
        <div class="form-group" *ngIf="entrepriseType == '1'">
            <label>Entreprise</label>
            <select name="idEntreprise" [(ngModel)]="idEntreprise" [ngModelOptions]="{standalone: true}" class="form-control">
                <option *ngFor="let entreprise of listEntreprise" value="{{entreprise.id}}">{{entreprise.name}}</option>
            </select>
        </div>
        <div class="form-group">
            <label>Commentaire</label>
            <textarea type="text" class="form-control" name="anomalyComment" [(ngModel)]="anomalyComment"></textarea>
        </div>
    </div>
    <div class="modal-footer">
        <button *ngIf="checkAction === 'add'" type="button" class="btn btn-info" (click)="addAnomaly()"><i class="fa fa-plus-circle" aria-hidden="true"></i> Ajouter</button>
        <button *ngIf="checkAction === 'update'" type="button" class="btn btn-info" (click)="updateAnomaly()"><i class="fa fa-check-circle" aria-hidden="true"></i> Enregister</button>
    </div>
</ng-template>

<ng-template #confirmDelete>
    <div class="card-body">
        Etes-vous sûr de vouloir supprimer?
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="deleteAnomaly()">OUI</button>  
        <button type="button" class="btn btn-outline-dark" (click)="resetField()">NON</button>         
    </div>
</ng-template>
